import React, { useEffect, useRef, useState } from 'react';
import WhiteContainer from '../../HOC/WrappingContainer/WhiteContainer';
import { useShowAudienceResult } from '../../../Hooks/Audience';
import { toast } from 'react-toastify';
import Loader from '../Loader/Loader';
import * as tableHeader from '../TableHeader/NewAudienceTableHeader';
import TableComponent from '../TableComponent/TableComponent';
import EmptyText from '../Custom/EmptyText';
import TableTopHeader from '../TableTopHeader/TableTopHeader';
import { useExportShowResult } from '../../../Hooks/UserAssignment';
import ColumnVisibility from '../TableTopHeader/ColumnVisibility';
import { useReactToPrint } from 'react-to-print';
import PrintComponent from '../Custom/ExportComponent/PrintComponent';
import NoDataComponent from '../Custom/NoData/NoDataComponent';

const SingleAudience = ({ audienceDetails }) => {
  const printRef = useRef();

  const [audienceData, setAudienceData] = useState([]);
  const [queryState, setQueryState] = useState({
    0: [],
    1: [],
    2: [],
  });
  const [valuesToExport, setValuesToExport] = useState({});

  const [visibleColumn, setVisibleColumn] = useState({
    name: true,
    applicationStart_Display: true,
    fieldOfInterest_Display: true,
    mobile: true,
    email: true,
    contactType_Display: true,
    userAssigned: false,
    statusText: false,
    type: true,
    nationality_Display: true,
    howDoYouHear_Display: false,
    selectedTerm_Display: true,
    noteCount: false,
    emailCount: false,
    sourceOfConnection: false,
    grade_Display: false,
    highSchoolGPA: false,
    curriculum_Display: false,
    lastEmailReceivedOnDisplay: false,
    priority_Display: false,
    country_Display: false,
    jobTitle: false,
    schoolName: false,
    createdOnDisplay: false,
  });

  const { mutate: showResult, isLoading: isShowingAudience } =
    useShowAudienceResult();
  const exportShowResult = useExportShowResult();

  useEffect(() => {
    if (audienceDetails) {
      setQueryState({
        0: audienceDetails
          ?.filter((item) => item.audienceType == 0)
          ?.map((item) => {
            return {
              andOr: item.andOr == 0 ? false : true,
              audienceOptionId: item.optionId,
              inNotIn: item.operatorId == 0 ? false : true,
              valueIds: item.valueId,
            };
          }),
        1: audienceDetails
          ?.filter((item) => item.audienceType == 1)
          ?.map((item) => {
            return {
              andOr: item.andOr == 0 ? false : true,
              audienceOptionId: item.optionId,
              inNotIn: item.operatorId == 0 ? false : true,
              valueIds: item.valueId,
            };
          }),
        2: audienceDetails
          ?.filter((item) => item.audienceType == 2)
          ?.map((item) => {
            return {
              andOr: item.andOr == 0 ? false : true,
              audienceOptionId: item.optionId,
              inNotIn: item.operatorId == 0 ? false : true,
              valueIds: item.valueId,
            };
          }),
      });
    }
  }, [audienceDetails]);

  const handleShowResult = () => {
    const mappedQueryState = {
      prospectFilters: queryState[0],
      leadFilters: queryState[1],
      externalContactFilters: queryState[2],
    };
    setValuesToExport(mappedQueryState);
    showResult(mappedQueryState, {
      onSuccess: (data) => {
        setAudienceData(data?.data);
        // if (
        //   !data?.data?.leads?.length > 0 &&
        //   !data?.data?.applicants?.length > 0 &&
        //   !data?.data?.externalContacts?.length > 0
        // ) {
        //   toast.error("No Audience Found");
        // }
      },
    });
  };

  useEffect(() => {
    handleShowResult();
  }, [audienceDetails, queryState]);

  const combinedData = audienceData
    ? [
        ...(Array.isArray(audienceData?.applicants)
          ? audienceData.applicants.map((applicant) => ({
              ...applicant,
              type: 'applicant',
              id: applicant.applicantId,
              name: applicant.lastName
                ? applicant.firstName +
                  ' ' +
                  applicant.middleName +
                  ' ' +
                  applicant.lastName
                : applicant.firstName,
            }))
          : []),
        ...(Array.isArray(audienceData?.externalContacts)
          ? audienceData.externalContacts.map((contact) => ({
              ...contact,
              type: 'contact',
              id: contact.externalContactId,
              name: contact.contactName,
            }))
          : []),
        ...(Array.isArray(audienceData?.leads)
          ? audienceData.leads.map((lead) => ({
              ...lead,
              type: 'lead',
              id: lead.studentId,
              name: lead.lastName
                ? lead.firstName + ' ' + lead.middleName + ' ' + lead.lastName
                : lead.firstName,
            }))
          : []),
      ]
    : [];

  console.log('bfgbfg', combinedData);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  const tableData = {
    data: {
      items: combinedData.map((item) => ({
        ...item,
        id: item.id,
      })),
    },
    refetch: null,
    isLoading: isShowingAudience,
    tableHeader: tableHeader.newAudienceTableHeader,
  };
  const rightButtons = (
    <ColumnVisibility
      tableHeader={tableHeader.newAudienceTableHeader}
      visibleColumn={visibleColumn}
      setVisibleColumn={setVisibleColumn}
    />
  );

  return (
    <WhiteContainer white>
      {isShowingAudience ? (
        <Loader />
      ) : combinedData?.length > 0 ? (
        <>
          <TableTopHeader
            leftComponent={
              <div>
                <h1 style={{ fontWeight: '700', fontSize: '16px' }}>
                  Future Learners League
                </h1>
                <h3 style={{ fontWeight: '500', fontSize: '14px' }}>
                  Total: {combinedData?.length}
                </h3>
              </div>
            }
            rightButtons={rightButtons}
            handlePrint={handlePrint}
            exportData={{
              visibleColumn: visibleColumn,
              tableHeader: tableHeader.newAudienceTableHeader,
              fileName: 'AudienceExport',
              combinedData: combinedData,
              isData: true,
            }}
          />
          <TableComponent
            tableData={tableData}
            isLoading={false}
            visibleColumn={visibleColumn}
            columnVisibility
            isResize
          />
        </>
      ) : (
        // <EmptyText text='Audience' />
        <NoDataComponent text='Audience' />
      )}
      <div style={{ display: 'none' }}>
        <PrintComponent
          ref={printRef}
          title='Audience Table'
          data={tableData}
        />
      </div>
    </WhiteContainer>
  );
};

export default SingleAudience;
